import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import NavbarMain from '../components/header/header';
import Footer from '../components/footer';

const NotFoundPage = () => {
  return (
    <>
      <SEOHead
        title="Page Not Found - RapidGoo"
        description="The page you're looking for doesn't exist or may have been moved. Return to RapidGoo's homepage to find business, IT, and AI services in the UAE."
        url="/404"
        noindex
        canonical={false}
      />
      <NavbarMain />
      <section className="py-5">
        <div className="container text-center py-5">
          <h1 className="display-4 fw-bold mb-3">Page not found</h1>
          <p className="lead text-muted mb-4">
            Sorry, we couldn&apos;t find the page you&apos;re looking for. It may have been moved or no longer exists.
          </p>
          <Link to="/home" className="btn btn-primary btn-lg">
            Back to Home
          </Link>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default NotFoundPage;
